import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { isTokenCurrent } from "../utils/tokenUtils";

export default function PublicRoute() {
  const { accessToken, refreshToken } = useSelector((state: RootState) => state.auth);
  return isTokenCurrent(accessToken) || isTokenCurrent(refreshToken) ? <Navigate to="/" replace /> : <Outlet />;
}
